@for (message of messages(); track message.id) {
    <app-message [message]="message" animate.enter="enter" animate.leave="leave" />
}
